<template>
	<!--图片上传-->
	<div>
		<el-upload :class="{uoloadSty:showBtnImg,disUoloadSty: localImg == '' ? noneBtnImg:localImg}" action="#"
			list-type="picture-card" :http-request="UploadImage" :on-preview="handlePictureCardPreview"
			:on-remove="handleRemove" :limit="limitImg" :file-list="fileList" :on-change="imgChange" 
			 :multiple="multiple" accept=".jpg,.png,.jpeg">
			<i class="el-icon-plus" />
		</el-upload>
		<el-dialog :append-to-body="true" :visible.sync="dialogVisible">
			<img width="100%" :src="dialogImageUrl" alt="" />
		</el-dialog>
	</div>
</template>

<script>
	import {
		uploadImg
	} from "../../request/apis.js"
	export default {
		props: {
			limitImg: { //最多上传图片数量
				type: Number
			},
			fileList: { //图片回显数组
				type: Array
			},
			type: { //区分同一个页面多个上传口子
				type: Number
			},
			noneBtnImg: {
				type: Boolean
			},
			multiple : Boolean
		},
		data() {
			return {
				imgIndexList: [],
				showBtnImg: true,
				localImg: '',
				dialogVisible: false,
				dialogImageUrl: '',
			};
		},
		methods: {
			//自定义图片上传
			UploadImage(param) {
				var fileSize = param.file.size / 1024 / 1024 < 50; //控制大小  修改50的值即可
				if (["image/jpg", "image/png", "image/jpeg"].indexOf(param.file.type) == -1) {
					this.$message.error("请上传格式正确的图片:jpg、png、jpeg");
					return false;
				}
				if (!fileSize) {
					this.$message.error("文件大小不能超过50M");
					return false;
				}
				const formData = new FormData();
				formData.append("image", param.file);
				formData.append("category", '1');
				uploadImg(formData).then(res => {
					if (res != -1) {
						this.imgIndexList.push(param.file.uid)
						this.$emit('saveImg', [res, this.type])
					} else {
						this.$message.error('图片上传服务器失败！请重新上传');
					}
				}).catch(err => {})
			},

			//显示与隐藏上传按钮
			imgChange(file, fileList) {
				this.localImg = fileList.length >= this.limitImg;
			},

			//查看图片
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},

			//删除图片
			handleRemove(file, fileList) {
				//判断是否是正确格式图片才能执行删除
				this.localImg = fileList.length >= this.limitImg;
				if (file && file.status === "success") {
					let Pics = this.fileList;
					Pics.forEach((item, index) => {
						if (file.uid == item.uid) {
							this.$emit('delImg', [index, this.type])
						}
					});
				}else {
					let Pics = this.imgIndexList;
					Pics.forEach((item, index) => {
						if (file.uid == item) {
							this.$emit('delImg', [(index + this.fileList.length), this.type])
							Pics.splice(index, 1);
						}
					});
				}
			},
		}
	}
</script>
<style scoped>
	/deep/.uoloadSty .el-upload--picture-card {
		width: 150px;
		height: 150px;
		line-height: 165px;
		margin-right: 20px;
		margin-bottom: 20px;
	}

	/deep/.uoloadSty .el-upload-list--picture-card .el-upload-list__item {
		width: 150px;
		height: 150px;
		border: 1px dashed #c0ccda;
		margin-bottom: 20px;
		margin-right: 20px;
	}

	/deep/.disUoloadSty .el-upload--picture-card {
		display: none;
		/* 上传按钮隐藏 */
	}

	/deep/.el-upload-list__item {
		transition: none !important;
	}
</style>